// src/components/ads-framework/ProductViewAnalytics.tsx

"use client"

import { useEffect, useRef } from "react"

import { trackViewItem } from "~/lib/ads-framework/storefront-analytics"
import type { StorefrontProduct } from "~/lib/analytics/registry"

/**
 * Fires a single GA4 `view_item` on mount for a storefront product page — the
 * top of the commerce funnel, so view→checkout drop-off is measurable. Render
 * once near the top of each product page (server component) with the SKU + list
 * price. Fire-once-per-mount guarded so a re-render can't double-count.
 */
export default function ProductViewAnalytics({
  product,
  priceUsd,
}: {
  product: StorefrontProduct
  priceUsd: number
}): null {
  const sent = useRef(false)
  useEffect(() => {
    if (sent.current) return
    sent.current = true
    void trackViewItem({ product, valueUsd: priceUsd })
  }, [product, priceUsd])
  return null
}
